<template>
  <div class="position-absolute v-header z-3">
    <div class="col-12">
      <div class="row">
        <div
          class="col-12 ps-4 pe-4 d-flex align-items-center justify-content-center v-theme-header"
        >
          <button @click="$router.go(-1)" class="btn-close-asset-rev"></button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="viewType == 'range' || viewType == 'renders'"
  >
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img
            :src="
              theme.cdnUrl +
              '/assets/' +
              assetType +
              '/' +
              viewType +
              '/' +
              this.assetTypes[this.order].LinkName
            "
            class="h-100"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Floorplans -->
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="viewType == 'floorplans' && this.assetTypesReady === true"
  >
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img
            :src="
              theme.cdnUrl +
              '/assets/' +
              assetType +
              '/' +
              viewType +
              '/' +
              this.assetTypes[this.order].LinkName
            "
            class="h-100"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Panoramas -->
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="
      viewType == 'virtual-tour' ||
      (viewType == 'balcony-views' && this.assetTypesReady === true)
    "
  >
    <iframe
      :src="this.assetUrls[this.order]"
      :title="this.assetUrls[this.order]"
      width="100%"
      height="100%"
    ></iframe>
  </div>

  <OffCanvas />
</template>

<script>
import DetailTopNav from "@/components/DetailTopNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
export default {
  name: "AssetViewDetail",
  props: ["assetType", "viewType", "order"],
  components: {
    DetailTopNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      currentAsset: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          "/assets/" +
          this.assetType +
          "/" +
          this.viewType +
          "/"
      ),
      currentIndex: null,
      assetNames: null,
      assetUrls: null,
      componentName: "AssetView",
      assetTypesReady: false,
    };
  },
  created() {
    if (this.assetType === "Type-A") {
      if (this.viewType === "videos") {
        this.assetOrder = this.theme.threeBedVillasAsset.videos;
        this.assetNames = this.theme.threeBedVillasAsset.videosName;
      } else if (this.viewType === "virtual-tour") {
        this.assetOrder = 0;
        this.assetNames = "Virtual Tour";
        this.assetUrls = this.theme.typeAAsset.virtualTourUrl;
      } else if (this.viewType === "balcony-views") {
        this.assetOrder = 0;
        this.assetNames = "Balcony View";
        this.assetUrls = this.theme.typeAAsset.balconyUrl;
      }
      this.assetTypesReady = true;
    }
  },
  methods: {
    // Reorder array based on config setup
    reorder: function (data_array, real_order) {
      var i,
        d = {},
        result = [];
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    },
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
